<template lang="pug">
div
  section.u-mt-md
    AppTitle(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        p.u-text-lg {{$t('sec2Desc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Social media",
    "pageDesc":"Reach your audience on different social media channels, increase brand awareness and build your brand community.",
    "mantra":"Socialize with |your  audience.",
    "mantraDesc":"Bridge the gaps and reach your audience anywhere with social media powers. Engage in meaningful conversations, build strong connections and increase your brand awareness within the community desired.",
    "sec1":"Cope up with the social move.",
    "sec1Items":{
      "1":{
        "title":"Social media strategy",
        "desc":"Setting the overall goals for your social media efforts and deciding on the channels that better supports your business and best matches your industry."
      },
      "2":{
        "title":"Content creation",
        "desc":"Translating your business goals into pieces of content with different formats and types that checkmate and deliver your marketing messages."
      },
      "3":{
        "title":"Campaign creation",
        "desc":"Planning and budgeting your advertising campaigns on social media to expand your brand presence and help you reach your target audience."
      }
    },
    "sec2":"Branded marketing assets.",
    "sec2Desc":"Through strategic visualization, we enhance the overall brand experience by keeping the consistency and aligning all the social media efforts with the brand strategy.",
    "sec3":"Explore the hidden powers of social media.",
    "sec3Items":{
      "1":{
        "title":"Brand awareness",
        "desc":"Spread the word about your brand and gain positive word of mouth by opening additional communication channels."
      },
      "2":{
        "title":"Community building",
        "desc":"Build relationships with your audience and create brand fan base. Answer your advocates questions and add up to your trust credit."
      },
      "3":{
        "title":"Sales increase",
        "desc":"Spread the word about your offerings, drive website traffic or engage with potential buyers through various social platforms."
      }
    },
    "cta":"Build your social <br> presence now."
  },
  "ar": {
    "pageTitle":"استراتيجيات التواصل الإجتماعي",
    "pageDesc":"تواصل مع جمهورك المستهدف في أي وقت وأي مكان من خلال مواقع التواصل الإجتماعي التي تساعدك على زيادة الوعي بهويتك.",
    "mantra":"انشر رسالتك من خلال |استراتيجيات التواصل الإجتماعي.",
    "mantraDesc":"تواصل مع جمهورك المستهدف في أي وقت وأي مكان من خلال خدمات مواقع التواصل الاجتماعي. انخرط في المحادثات ونميّ علاقاتك وابدأ في بناء الروابط التي تساعدك على زيادة الوعي بهويتك التجارية.",
    "sec1":"تواكب مع مواقع وسائل التواصل الاجتماعي.",
    "sec1Items":{
      "1":{
        "title":"استراتيجية وسائل التواصل الإجتماعي",
        "desc":"حدد الأهداف العامة وقنوات التواصل الاجتماعي التي ستظهر من خلالها، التي تدعم عملك التجاري وتتناسب مع مجالك، وكذلك يتواجد عليها جمهورك المستهدف باستمرار."
      },
      "2":{
        "title":"كتابة وإنشاء المحتوي",
        "desc":"ترجم أهداف عملك التجاري إلى محتوى ذات تنسيقات وأنواع  مختلفة، الذي يوصل رسالتك بشكل فعال ويترك انبطاعًا لدى جمهورك."
      },
      "3":{
        "title":"إنشاء الحملة",
        "desc":"خطط لحملتك الإعلانية على وسائل التواصل الإجتماعي؛ لتصل إلى جمهورك بشكل أوسع وتزيد الوعي بكل ما تقوم به لدى جمهورك."
      }
    },
    "sec2":"أصول التسويق للعلامة التجارية.",
    "sec2Desc":"من خلال الاستراتيجية البصرية التي ننشئها، نعمل على تعزيز العلامة التجارية بأكملها من خلال المواءمة بين جميع جهود مواقع وسائل التواصل الاجتماعي و استراتيجية العلامة التجارية.",
    "sec3":"استخدم وسائل التواصل الاجتماعي بفاعلية.",
    "sec3Items":{
      "1":{
        "title":"التوعية بالعلامة التجارية",
        "desc":"وسع من انتشار علامتك التجارية ودع عملائك يعرفون أكثر عنها، وافتح فرص جديدة للتواصل معهم عبر القنوات المختلفة."
      },
      "2":{
        "title":"بناء مجتمعك",
        "desc":"بناء علاقات مع عملائك لم تعد مهمة صعبة، يمكنك الانخراط من الآن في المحادثات وبناء قاعدة جماهيرية لك، وكذلك الإجابة على جميع الاستفسارات التي تشغل بالهم."
      },
      "3":{
        "title":"زيادة المبيعات",
        "desc":"يمكنك توضيح كافة التفاصيل عن منتجاتك وعروضك عبر كافة وسائل التواصل الاجتماعي، وكذلك زيادة زوار موقعك من خلال محتوى مميز يعبر عنك."
      }
    },
    "cta":"ابدأ في بناء <br> علاقاتك الآن! "
  }
}
</i18n>
